// extracted by mini-css-extract-plugin
module.exports = {"disclaimer":"disclaimer__2PZQl","container":"container__1tOyx","button":"button__29Vpq"};